import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/equalture.webp';
import screenshot_target from '../../../images/letterfunnel/jaaphaagmans.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Jaap Haagmans"
      firstname="Jaap"
      companyname="Equalture"
      competition="TestGorilla en Harver"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jaaphaagmans.js